import React from "react";
import LegalPage, { H2, P, UL } from "./LegalPage";

export default function Refund() {
  return (
    <LegalPage title="Refund & Return Policy">

      <H2>1. Perishable Items</H2>
      <P>
        Due to the perishable nature of vegetables, fruits, meat, dairy, and
        fresh products:
      </P>
      <UL>
        <li>Returns must be requested within 24 hours of delivery</li>
        <li>Items must be unused and in original condition</li>
      </UL>

      <H2>2. Damaged or Incorrect Items</H2>
      <P>If you receive damaged, expired, or incorrect items:</P>
      <UL>
        <li>Report within 24 hours via app or support email</li>
      </UL>

      <H2>3. Non-Returnable Items</H2>
      <P>
        Opened or partially used items may not be eligible unless defective.
      </P>

      <H2>4. Refund Method</H2>
      <UL>
        <li>Original payment method</li>
        <li>Or Grox24 wallet credit (if applicable)</li>
      </UL>

      <P>
        Refund timelines may vary based on payment provider processing time.
      </P>

    </LegalPage>
  );
}